import { ConfigServiceModel } from '@app/origami-api/services/config.service';
import { containsBit, Field } from '@app/origami-api/constants/field-flag';
import { TopicTypeNameById } from '@app/origami-api/constants/topic-type-names';

export const isIgnoredField = (field: ConfigServiceModel.Field): boolean => {
  return (
    Field.Is.defaultVirtual(field) || (!containsBit(field.Flags, Field.Flag.CustomOption3) && Field.Is.hidden(field))
  );
};

export const resolveFieldTitle = (field: ConfigServiceModel.Field, topicTypeId: number): string => {
  const topicTypeName = TopicTypeNameById[topicTypeId];
  const defaultsInDefaultLocale = tiStrings.shared.defaultFieldTitlesDefault[topicTypeName] || {};
  const defaults = tiStrings.shared.defaultFieldTitles[topicTypeName] || {};

  return field.Title === defaultsInDefaultLocale[field.FieldName]
    ? defaults[field.FieldName]
    : field.Title || field.DefaultTitle;
};

/**
 * Inverse of resolveFieldTitle: when the title matches the English or current-locale default
 * from tiStrings, persist NULL so the backend keeps "use default" semantics
 * (TRL-8258 / dbo.GetDefaultForms). Custom titles are returned as-is.
 */
export const resolvePersistedTitle = (field: ConfigServiceModel.Field, topicTypeId: number): string | null => {
  const topicTypeName = TopicTypeNameById[topicTypeId];
  if (!topicTypeName || !field.FieldName) {
    return field.Title ?? null;
  }

  const enDefault = tiStrings.shared.defaultFieldTitlesDefault[topicTypeName]?.[field.FieldName];
  const localeDefault = tiStrings.shared.defaultFieldTitles[topicTypeName]?.[field.FieldName];

  if (enDefault !== undefined && field.Title === enDefault) {
    return null;
  }
  if (localeDefault !== undefined && field.Title === localeDefault) {
    return null;
  }

  return field.Title ?? null;
};
